import { useEffect } from "react"
import { useParams } from "react-router-dom"

import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"

import SentryForm from "../../Shared/SentryForm/SentryForm"

function ErrorFallback(props) {
  const params = useParams()

  const { backgroundProcessor, setAppBarTitle } = props

  useEffect(() => {
    setAppBarTitle("Error")

    if (backgroundProcessor?.tasks) backgroundProcessor?.reset()
  }, [])

  return (
    <Grid
      container
      direction="column"
      alignContent="center"
      style={{ paddingBottom: "1rem" }}
    >
      <Grid container item direction="column" style={{ maxWidth: "640px" }}>
        <Paper elevation={3} className="MuiPaper-core">
          <Grid container>
            <Grid item style={{ flexGrow: 1 }}>
              <SentryForm {...props} eventId={params.id} />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default ErrorFallback
